import { useNavigate } from "react-router-dom";
import StatCard from "../../components/ui/StatCard";
import LatestActivityCard from "./LatestActivityCard";
import { useFetchProducts } from "../../hooks/products/useFetchProducts";
import { BellRing, Box, IndianRupee, Pill } from "lucide-react";
import { useFetchOrders } from "../../hooks/orders/useFetchOrders";
import { useFetchInfo } from "../../hooks/orders/useFetchInfo";
import { useUnreadNotification } from "../../hooks/notification/useUnreadNotification";

export default function Dashboard() {
  const navigate = useNavigate();

  const { data } = useFetchInfo();

  const { data: products } = useFetchProducts();

  const {
    data: orders,
    isLoading: loadingOrders,
  } = useFetchOrders({
    page: 1,
    page_size: 6,
  });

  const { data: notifications, isLoading: loadingNotifications } = useUnreadNotification();
  
  const productQuantity = products?.length;
  const totalRevenue = data?.totalAmount;
  const ordersQuantity = data?.totalOrders;
  const notificationCount = notifications?.length;

  const Stats = [
    {
      label: "Total Revenue",
      value: totalRevenue,
      icon: <IndianRupee />,
      color: "bg-emerald-500",
      route: "/supplement",
    },
    {
      label: "Orders",
      value: ordersQuantity,
      icon: <Box />,
      color: "bg-blue-500",
      route: "/supplement/orders",
    },
    {
      label: "Products",
      value: productQuantity,
      icon: <Pill />,
      color: "bg-yellow-500",
      route: "/supplement/inventory",
    },
    {
      label: "Notifications",
      value: notificationCount,
      icon: <BellRing />,
      color: "bg-rose-500",
      route: "/supplement/notifications",
    },
  ];

  return (
    <div className="space-y-8 animate-in fade-in duration-500">
      <div className="flex justify-end">
        <button
          className=" px-3 py-1 rounded-xl border border-emerald-700 hover:bg-primary/20 transition-all duration-300 ease-in-out"
          onClick={() => navigate("/admin")}
        >
          Go Home
        </button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {Stats.map((stat) => (
          <StatCard
            label={stat.label}
            icon={stat.icon}
            value={stat.value}
            color={stat.color}
            route={stat.route}
          />
        ))}
      </div>

      <div className="w-full">
        <LatestActivityCard
          orders={orders}
          notifications={notifications}
          loadingNotifications={loadingNotifications}
          loadingOrders={loadingOrders}
        />
      </div>
    </div>
  );
}
